import { render, staticRenderFns } from "./DsfExamRecord.vue?vue&type=template&id=5f621f50&"
import script from "./DsfExamRecord.vue?vue&type=script&lang=js&"
export * from "./DsfExamRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfExamRecord.vue"
export default component.exports